import React, { useMemo } from 'react';
import Paper from '@material-ui/core/Paper';

import ActivityCard from 'components/ActivityCard';
import SpeedIcon from '@material-ui/icons/Mood';

import { useStyles } from '../styles';

interface IProps {
  activityReport: any; // TODO: improve this
  withoutPaper?: boolean;
  withoutIcon?: boolean;
  float?: boolean;
  withoutChip?: boolean;
}

const MoodCounter: React.FC<IProps> = ({
  activityReport,
  withoutPaper,
  withoutIcon,
  withoutChip,
}) => {
  const classes = useStyles();

  const moodCounter = useMemo(() => {
    if (!activityReport) return 0;
    return {
      currentMood:
        (activityReport.metricsGauges.length && activityReport.metricsGauges[0].moodAvg) || 0,
      previousMood:
        (activityReport.previousMetricsGauges.length &&
          activityReport.previousMetricsGauges[0].moodAvg) ||
        0,
    };
  }, [activityReport]);

  return (
    <>
      {!withoutPaper ? (
        <Paper className={classes.paper}>
          <ActivityCard
            icon={<SpeedIcon style={{ marginRight: '5px' }} />}
            title={'Overall Sentiment'}
            data={moodCounter}
            float={true}
            withoutIcon={withoutIcon}
            withoutChip={withoutChip}
          />
        </Paper>
      ) : (
        <ActivityCard
          icon={<SpeedIcon style={{ marginRight: '5px' }} />}
          title={withoutPaper ? 'Environment' : 'Overall Sentiment'}
          data={moodCounter}
          float={true}
          withoutIcon={withoutIcon}
          withoutChip={withoutChip}
        />
      )}
    </>
  );
};

export { MoodCounter };
